module.exports = __webpack_public_path__ + "static/media/btn-login-azure.3b691287.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/btn-login-azure.svg
// module id = 412
// module chunks = 1